import { ResetPasswordRequest, UserControllerApi } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
interface Params {
  linkType: "reset" | "set";
  ResetPasswordRequest: ResetPasswordRequest;
  xTENANTID?: string;
}

export const useResetPassword = () =>
  useMutationWithLoading(async (params: Params) =>
    new UserControllerApi(getConfigObject()).setPassword(
      params.linkType,
      params.ResetPasswordRequest,
      params.xTENANTID
    )
  );
